import { render, staticRenderFns } from "./AdminMoneyIcon.vue?vue&type=template&id=cc27e7f8&scoped=true"
var script = {}
import style0 from "./AdminMoneyIcon.vue?vue&type=style&index=0&id=cc27e7f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc27e7f8",
  null
  
)

export default component.exports